<template lang="pug">
  // E-mail変更
  #change-mail-form
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-button.ml-3.mb-2(v-b-modal.order_confirm, variant="outline-success", :disabled="isSendButtonDisabled") 送信する
      b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="addChangeMail", ok-title="はい", cancel-title="いいえ")
          span 入力内容を送信します。<br>本当によろしいですか？
      p.ml-3.text-left
        | ※E-mail変更に伴い、メールアドレス変更URLを記載したメールを送信いたします。
        br
        | ※受信可能なメールアドレスを入力してください。
      b-container(fluid="fluid")
        b-row
          b-col
            b-row.border-top.ml-3.mr-1
              b-col(:class="customer_title_col_class")
              b-col(:class="customer_now_data_title_col_class") 現在の登録情報
              b-col.font-weight-bold(:class="customer_input_col_class") 変更後の登録情報
            b-row.border-top.ml-3.mr-1
              b-col(:class="customer_title_col_class") E-mail
              b-col(:class="customer_now_data_col_class") {{e_mail}}
              b-col(:class="customer_input_col_class")
                b-form-input(size="sm", type="text", v-model="change_mail_address.value", :placeholder="change_mail_address.placeholder", :class="change_mail_address.form_class", :state="change_mail_address.error_msg_list.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of change_mail_address.error_msg_list") {{error_msg}}
            b-row.border-bottom.ml-3.mr-1
              b-col(:class="customer_title_col_class")
              b-col(:class="customer_now_data_col_class")
              b-col(:class="customer_input_col_class")
                b-form-input(size="sm", type="text", v-model="re_change_mail_address.value", :placeholder="re_change_mail_address.placeholder", :class="re_change_mail_address.form_class", :state="re_change_mail_address.error_msg_list.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of re_change_mail_address.error_msg_list") {{error_msg}}
      b-button.ml-3.mt-2(v-b-modal.order_confirm, variant="outline-success", :disabled="isSendButtonDisabled") 送信する
</template>

<script>
import Api from "@/repositories/api";
import Loading from '@/components/Loading';

const S207MailChangesRepository = Api.get("s207MailChanges");

export default {
  name: "ChangeMailForm",
  components: {
    Loading
  },
  data() {
    return {
      customer_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      customer_input_col_class: "py-2 px-2",
      customer_now_data_title_col_class: "py-2 px-2 border-right table-now-data-col-width font-weight-bold",

      customer_now_data_col_class: "py-2 px-2 border-right table-now-data-col-width",

      // 現在登録されているメールアドレス
      e_mail: '',

      // 変更後のメールアドレス
      change_mail_address: {
        value: "",
        placeholder: "（半角英数字）",
        error_msg_list: [],
        form_class: "middle-form-size"
      },
      // 変更後の確認用メールアドレス
      re_change_mail_address: {
        value: "",
        placeholder: "確認のためもう一度入力してください",
        error_msg_list: [],
        form_class: "middle-form-size"
      },

      // 読み込み中フラグ
      isLoading: false,

      // 送信ボタン用フラグ
      isSendButtonDisabled: false
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // お客様情報取得
    S207MailChangesRepository.get()
    .then((response) => {
      // メールアドレスセット
      this.e_mail = response.data.data.e_mail
    })
    .catch((error) =>{
      // httpステータスコードが403の場合（権限エラー）
      if (error.response.status === 403) {
        // アプリケーションエラー画面へ遷移する
        this.$router.push({
          name: 'SupportApplicationError',
          params: {
            // 画面に表示するエラーメッセージ
            error_msg: this.forbidden_message
          }
        })
      }

      // 共通のエラー処理
      this.apiError(error, '画面表示処理', "Support")
    })
    .finally(() => [
      // 読み込み完了
      this.isLoading = false
    ])
  },
  methods: {
    /*
    * メール変更依頼管理テーブルに変更情報を追加する
    */
    addChangeMail() {
      // 入力オブジェクト取得
      const vueData = this;
      // 入力データセット
      let arInputData = {
        change_mail_address: vueData.change_mail_address.value,
        re_change_mail_address: vueData.re_change_mail_address.value
      };

      // 「送信する」ボタンをロックする
      this.isSendButtonDisabled = true;

      // 登録処理呼び出し
      S207MailChangesRepository.post(arInputData)
      // 登録処理成功
      .then (() => {
        this.$router.push ({
          name: 'ChangeMailReception',
          params: {
            p_mail_address: this.change_mail_address.value
          }
        })
      })
      // 入力値エラー処理
      .catch((error) => {
        // 「送信する」ボタンをロックを解除する
        this.isSendButtonDisabled = false;

        // 共通のエラー処理
        this.apiError(error, '登録処理', "Support")

        // 既存のエラーメッセージをリセット
        vueData.change_mail_address.error_msg_list = [];
        vueData.re_change_mail_address.error_msg_list = [];

        // エラーリストの読み込み
        const arErrorList = error.response.data.error_list;

        // 各エラーメッセージを画面に埋め込む
        for (let i = arErrorList.length -1; i >= 0; i--) {
          switch (arErrorList[i].target) {
            case "change_mail_address":
              vueData.change_mail_address.error_msg_list.push(arErrorList[i].error_msg)
              break
            case "re_change_mail_address":
              vueData.re_change_mail_address.error_msg_list.push(arErrorList[i].error_msg)
              break
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.table-title-col-width {
  max-width: 180px;
}
.table-now-data-col-width {
  max-width: 230px;
}
.middle-form-size {
  max-width: 500px;
}
</style>